import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { HiOutlineLogout } from "react-icons/hi";
import "./Sidebar.css";
import LogoutModal from "../DashboardNavbar/LogoutModal/LogoutModal";

const Sidebar = ({ isOpen, onItemClick, toggleSidebar }) => {
  const location = useLocation();
  const isChatRoute = location.pathname.startsWith("/chat");
  const [hoveredPath, setHoveredPath] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const handleLogoutClick = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const isActive = (path) => {
    const { pathname } = location;

    if (path === "/queries") {
      return (
        pathname === "/queries" || pathname.startsWith("/chat/queries")
      );
    }

    if (path === "/my-quote") {
      return (
        pathname === "/my-quote" || pathname.startsWith("/chat/quote/")
      );
    }

    if (path === "/bookings") {
      return (
        pathname.startsWith("/bookings") ||
        pathname.startsWith("/chat/booking")
      );
    }

    if (path === "/services") {
      return (
        location.pathname === "/services" ||
        location.pathname.startsWith("/services-pricing")
      );
    }

    if (path === "/photographer") {
      return (
        location.pathname === "/photographer" ||
        location.pathname.startsWith("/photographer-profile")
      );
    }

    return location.pathname === path;
  };

  const menuItems = [
    {
      name: "Dashboard",
      path: "/dashboard",
      activeIcon: "/Icons/dashboard-active.png",
      inactiveIcon: "/Icons/dashboard-inactive.png",
    },
    {
      name: "Queries",
      path: "/queries",
      activeIcon: "/Icons/queries-active.png",
      inactiveIcon: "/Icons/queries-inactive.png",
    },
    {
      name: "My Quote",
      path: "/my-quote",
      activeIcon: "/Icons/quote-active.png",
      inactiveIcon: "/Icons/quote-inactive.png",
    },
    {
      name: "Shoot Booking",
      path: "/bookings",
      activeIcon: "/Icons/camera-active.png",
      inactiveIcon: "/Icons/camera-inactive.png",
    },
    {
      name: "Payments",
      path: "/payment",
      activeIcon: "/Icons/payment-active.png",
      inactiveIcon: "/Icons/payment-inactive.png",
    },
    {
      name: "Customers",
      path: "/customer",
      activeIcon: "/Icons/customer-active.png",
      inactiveIcon: "/Icons/customer-inactive.png",
    },
    {
      name: "Join Us",
      path: "/join-us",
      activeIcon: "/Icons/join-us-active.png",
      inactiveIcon: "/Icons/join-us-inactive.png",
    },
    {
      name: "Contact Us",
      path: "/contact-us",
      activeIcon: "/Icons/contact-us-active.png",
      inactiveIcon: "/Icons/contact-us-inactive.png",
    },
    {
      name: "Services",
      path: "/services",
      activeIcon: "/Icons/service-active.png",
      inactiveIcon: "/Icons/service-inactive.png",
    },
    {
      name: "Gallery Plan",
      path: "/gallery-plan",
      activeIcon: "/Icons/galleryPlan-active.png",
      inactiveIcon: "/Icons/galleryPlan-inactive.png",
    },
    {
      name: "Photographers",
      path: "/photographer",
      activeIcon: "/Icons/photographer-active.png",
      inactiveIcon: "/Icons/photographer-inactive.png",
    },
    {
      name: "Commission",
      path: "/commission",
      activeIcon: "/Icons/commission-active.png",
      inactiveIcon: "/Icons/commission-inactive.png",
    },
    {
      name: "Roles",
      path: "/role",
      activeIcon: "/Icons/role-active.png",
      inactiveIcon: "/Icons/role-inactive.png",
    },
    {
      name: "Staff",
      path: "/staff",
      activeIcon: "/Icons/staff-active.png",
      inactiveIcon: "/Icons/staff-inactive.png",
    },
    {
      name: "Subscribers",
      path: "/subscribers",
      activeIcon: "/Icons/subscribers-active.png",
      inactiveIcon: "/Icons/subscribers-inactive.png",
    },
    {
      name: "Promocode",
      path: "/promocode",
      activeIcon: "/Icons/promocode-active.png",
      inactiveIcon: "/Icons/promocode-inactive.png",
    },
    {
      name: "Tickets",
      path: "/tickets",
      activeIcon: "/Icons/queries-active.png",
      inactiveIcon: "/Icons/queries-inactive.png",
    },
  ];

  return (
    <div className={`sidebar ${isOpen ? "open" : "closed"}${isChatRoute ? " sidebar--chat-route" : ""}`}>
      {isChatRoute && (
        <div className="sidebar-brand">
          <img
            src="/ProjectLogo/photography_logo.png"
            alt="Veroa Studioz"
            className="sidebar-brand-logo"
          />
          {toggleSidebar && (
            <button
              type="button"
              className="sidebar-brand-toggle"
              onClick={toggleSidebar}
              aria-label="Toggle menu"
            >
              <img
                src={isOpen ? "/Icons/hamburger.png" : "/Icons/arrow.png"}
                alt=""
              />
            </button>
          )}
        </div>
      )}
      <ul
        className="sidebar-menu"
        style={{ marginTop: isChatRoute ? "8px" : "8vh" }}
      >
        {menuItems.map((item) => (
          <Link to={item.path} key={item.path} onClick={onItemClick}>
            <li
              className={`menu-item ${isActive(item.path) ? "active" : ""}`}
              onMouseEnter={() => setHoveredPath(item.path)}
              onMouseLeave={() => setHoveredPath(null)}
            >
              <img
                src={
                  isActive(item.path) || hoveredPath === item.path
                    ? item.activeIcon
                    : item.inactiveIcon
                }
                alt={item.name}
                className="sidebar-png-icon"
              />

              {isOpen && <span>{item.name}</span>}
            </li>
          </Link>
        ))}

        {/* Logout (static like your original) */}
        {/* <Link to="/logout" onClick={handleLogoutClick}>
          <li
            className={`menu-item ${
              location.pathname === "/logout" ? "active" : ""
            }`}
          >
            <HiOutlineLogout size={20} />
            {<span>Logout</span>}
          </li>
           <LogoutModal isOpen={isModalOpen} onClose={closeModal} />
        </Link> */}
        <li
  className="menu-item"
  onClick={handleLogoutClick}
>
  <HiOutlineLogout size={20} />
  {isOpen && <span>Logout</span>}
</li>

 <LogoutModal isOpen={isModalOpen} onClose={closeModal} />
       
      </ul>

       
    </div>
  );
};

export default Sidebar;




// import React, { useState } from "react";
// import { Link, useLocation } from "react-router-dom";

// // All icons from react-icons/hi
// import {
//   HiOutlineViewGrid,
//   HiOutlineLogout,
// } from "react-icons/hi";

// import "./Sidebar.css";
// const Sidebar = ({ isOpen, onItemClick }) => {
//   const location = useLocation();
//   const [hoveredPath, setHoveredPath] = useState(null);

//   const isActive = (path) => {
//     if (path === "/my-quote") {
//       return (
//         location.pathname === "/my-quote" ||
//         location.pathname.startsWith("/chat/quote")
//       );
//     }

//       // Bookings + Booking Chat  ✅ ADD THIS
//   if (path === "/bookings") {
//     return (
//       location.pathname === "/bookings" ||
//       location.pathname.startsWith("/chat/booking") ||
//       location.pathname.startsWith("/bookings/upload-gallery")
//     );
//   }
//   if (path === "/services") {
//     return (
//       location.pathname === "/services" ||
//       location.pathname.startsWith("/services-pricing")
//     );
//   }

//   if (path === "/photographer") {
//     return (
//       location.pathname === "/photographer" ||
//       location.pathname.startsWith("/photographer-profile")
//     );
//   }
//     return location.pathname === path;
//   };



//   const menuItems = [
//     {
//       name: "Dashboard",
//       icon: <HiOutlineViewGrid size={25} />,
//       path: "/dashboard",
//     },
//     {
//       name: "Bookings",
//       path: "/bookings",
//       icon: (
//         <img
//           src={
//             isActive("/bookings")
//               ? "/Icons/camera-active.png"
//               : hoveredPath === "/bookings"
//                 ? "/Icons/camera-active.png"
//                 : "/Icons/camera-inactive.png"
//           }
//           alt="Bookings"
//           className="sidebar-png-icon"
//         />
//       ),
//     },
//     {
//       name: "My Quote",
//       path: "/my-quote",
//       icon: (
//         <img
         
//           src={
//             isActive("/my-quote")
//               ? "/Icons/quote-active.png"
//               : hoveredPath === "/my-quote"
//                 ? "/Icons/quote-active.png"
//                 : "/Icons/quote-inactive.png"
//           }

//           alt="my-quote"
//           className="sidebar-png-icon"
//         />
//       ),
//     },

//      {
//       name: "Services",
//       path: "/services",
//       icon: (
//         <img
//           src={
//             isActive("/services")
//               ? "/Icons/service-active.png"
//               : hoveredPath === "/services"
//                 ? "/Icons/service-active.png"
//                 : "/Icons/service-inactive.png"
//           }
//           alt="service"
//           className="sidebar-png-icon"
//         />
//       ),
//     },

//     {
//       name: "Payment",
//       path: "/payment",
//       icon: (
//         <img
//           src={
//             location.pathname === "/payment"
//               ? "/Icons/payment-active.png"
//               : hoveredPath === "/payment"
//                 ? "/Icons/payment-active.png"
//                 : "/Icons/payment-inactive.png"
//           }
//           alt="payment"
//           className="sidebar-png-icon"
//         />
//       ),
//     },
//     {
//       name: "Customer",
//       path: "/customer",
//       icon: (
//         <img
//           src={
//             location.pathname === "/customer"
//               ? "/Icons/customer-active.png"
//               : hoveredPath === "/customer"
//                 ? "/Icons/customer-active.png"
//                 : "/Icons/customer-inactive.png"
//           }
//           alt="customer"
//           className="sidebar-png-icon"
//         />
//       ),
//     },

//     {
//       name: "Subscribers",
//       path: "/subscribers",
//       icon: (
//         <img
//           src={
//             location.pathname === "/subscribers"
//               ? "/Icons/subscribers-active.png"
//               : hoveredPath === "/subscribers"
//                 ? "/Icons/subscribers-active.png"
//                 : "/Icons/subscribers-inactive.png"
//           }
//           alt="subscribers"
//           className="sidebar-png-icon"
//         />
//       ),
//     },


//     {
//       name: "Photographer",
//       path: "/photographer",
//       icon: (
//         <img
//           src={
//             isActive("/photographer") 
//               ? "/Icons/photographer-active.png"
//               : hoveredPath === "/photographer"
//                 ? "/Icons/photographer-active.png"
//                 : "/Icons/photographer-inactive.png"
//           }
//           alt="photographer"
//           className="sidebar-png-icon"
//         />
//       ),
//     },

//     {
//       name: "Role",
//       path: "/role",
//       icon: (
//         <img
//           src={
//             location.pathname ==="/role" 
//               ? "/Icons/role-active.png"
//               : hoveredPath === "/role"
//                 ? "/Icons/role-active.png"
//                 : "/Icons/role-inactive.png"
//           }
//           alt="role"
//           className="sidebar-png-icon"
//         />
//       ),
//     },

//      {
//       name: "Commission",
//       path: "/commission",
//       icon: (
//         <img
//           src={
//             location.pathname ==="/commission" 
//               ? "/Icons/commission-active.png"
//               : hoveredPath === "/commission"
//                 ? "/Icons/commission-active.png"
//                 : "/Icons/commission-inactive.png"
//           }
//           alt="commission"
//           className="sidebar-png-icon"
//         />
//       ),
//     },

    





//     {
//       name: "Logout",
//       icon: <HiOutlineLogout size={20} />,
//       path: "/logout",
//     },
//   ];

//   return (
//     <div className={`sidebar ${isOpen ? "open" : "closed"}`}>
//       <ul className="sidebar-menu" style={{ marginTop: "8vh" }}>
//         {menuItems.map((item) => (
//           // <Link to={item.path} key={item.path}>
//           //   {/* <li
//           //     className={`menu-item ${
//           //       location.pathname === item.path ? "active" : ""
//           //     }`}
//           //   > */}
//           //   <li
//           //     className={`menu-item ${location.pathname === item.path ? "active" : ""
//           //       }`}
//           //     onMouseEnter={() => setHoveredPath(item.path)}
//           //     onMouseLeave={() => setHoveredPath(null)}
//           //   >

//           //     {item.icon}
//           //     {isOpen && <span>{item.name}</span>}
//           //   </li>
//           // </Link>

//           <Link to={item.path} key={item.path} onClick={onItemClick}>
//             <li
//               className={`menu-item ${isActive(item.path) ? "active" : ""}`}

//               onMouseEnter={() => setHoveredPath(item.path)}
//               onMouseLeave={() => setHoveredPath(null)}
//             >
//               {item.icon}
//               {isOpen && <span>{item.name}</span>}
//             </li>
//           </Link>

//         ))}
//       </ul>
//     </div>
//   );
// };

// export default Sidebar;
